var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"refresh-page"},[_c('div',{staticClass:"button access-button",on:{"click":_vm.refresh}},[_vm._v(" REFRESH ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }